import { Component, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-silent-renew',
  template: '<p>Processing silent renew...</p>',
})
export class SilentRenewComponent implements OnInit {
  constructor(private oidcSecurityService: OidcSecurityService) {}

  ngOnInit(): void {
    console.log('SilentRenewComponent initialized');

    this.oidcSecurityService.checkAuth().subscribe((res: any) => {
        console.log('Auth',res);
        
    })

    // Handle the silent renew callback
    // this.oidcSecurityService.checkAuthIncludingServer().subscribe((res: any) => {
    //     console.log(res);
        
    // })
    this.oidcSecurityService.checkAuthIncludingServer().subscribe({
      next: (result) => {
        console.log('Silent renew callback processed:', result);
      },
      error: (error) => {
        console.error('Error during silent renew callback:', error);
      },
    });
  }
}
